<section mat-dialog-title>
  <span>Execute {{ data.isRemoteAction ? 'Remote' : '' }} Action?</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content>
  <avs-message type="warning">
    This action will affect its child devices. Are you sure you want to execute the action?
  </avs-message>
  <div class="flex flex-row pt-4">
    <avs-action-point-value-selector
      class="w-full"
      (valueChanged)="value.set($event)"
      [actionPoint]="data.actionPoint"
    />
  </div>
</mat-dialog-content>
<mat-dialog-actions
  class="pb-6 px-8 gap-x-4 "
  align="end"
>
  <button
    class="btn-transparent btn-medium"
    mat-dialog-close
  >
    Cancel
  </button>
  <button
    class="btn-green btn-medium"
    (click)="data.isRemoteAction ? executeRemoteAction() : executeDeviceAction()"
    [disabled]="isLoading()"
  >
    Execute
    @if (isLoading()) {
      <mat-spinner diameter="20" />
    }
  </button>
</mat-dialog-actions>
